import React from 'react';
import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

interface Props {
  label: string;
  value: string;
  indicator?: string;
}

const Background = styled(Box)`
  position: absolute;
  max-width: none;
  left: -8px;
  right: -8px;
  top: 0;
  bottom: 0;
  z-index: 1;
`;

const PlanDetailRow: React.FC<Props> = ({ label, value, indicator }) => {
  return (
    <Box style={{ position: 'relative' }}>
      {indicator && <Background round="dropdownItemRound" background="missingDetailsFade" />}

      <Box
        direction="row"
        height="24px"
        align="center"
        justify="between"
        fill="horizontal"
        data-testid={`plan-detail-row_${label}`}
        style={{ zIndex: 2 }}
      >
        <Text
          size="medium"
          weight={400}
          truncate
          title={label}
          data-testid={`plan-detail-row_${label}_label`}
        >
          {label}
        </Text>
        <Box direction="row" align="center" gap="spacing8" flex={{ shrink: 0 }}>
          <Text
            size="medium"
            weight={700}
            truncate
            title={value}
            data-testid={`plan-detail-row_${label}_value`}
          >
            {value}
          </Text>
          {!!indicator && (
            <Text
              size="medium"
              weight={700}
              color="missingDetail"
              style={{ whiteSpace: 'nowrap' }}
              data-testid={`plan-detail-row_${label}_indicator`}
            >
              ({indicator})
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PlanDetailRow;
